/*=========================================================================================
  File Name: module-agreement.js
  Description: Agreement Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-agreement-state';
import mutations from './module-agreement-mutations';
import actions from './module-agreement-actions';
import getters from './module-agreement-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
